export default __webpack_public_path__ + "static/media/09_croco_m.d900c6b9.webp";